import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { type APICouponResponse, fetchCoupon as makeCouponRequest } from '@/utils/api/coupon';

interface Coupon {
  code?: string;
  discountPercentage?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CouponState extends Coupon {
  isLoading: boolean;
}

const initialState: CouponState = {
  isLoading: true,
};

export const fetchCoupon = createAsyncThunk<{ coupon?: APICouponResponse | null }>('fetchCoupon', makeCouponRequest);

export const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchCoupon.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCoupon.fulfilled, (state, action) => {
      if (action.payload.coupon) {
        // should be `null` here, if no code applied
        state.code = action.payload.coupon.coupon_code;
        state.discountPercentage = action.payload.coupon.coupon_dicount_percent;
        state.createdAt = action.payload.coupon.created_at;
        state.updatedAt = action.payload.coupon.updated_at;
      }

      state.isLoading = false;
    });
  },
});
